import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice holding the currently active organization entry.
 */
export const organizationSlice = createSlice({
  name: 'organization',

  initialState: {
    entry: { id: null }
  },

  reducers: {
    updateOrganization: (state, action) => {
      state.entry = action.payload
    },

    resetOrganization: state => {
      state.entry = { id: null }
    }
  }
})

/**
 * `updateOrganization` sets the active organization entry; `resetOrganization` resets it to `{ id: null }`.
 */
export const { updateOrganization, resetOrganization } = organizationSlice.actions

/**
 * Selects the currently active organization entry.
 *
 * @param {Object} state - Redux state.
 * @returns {Object} Organization entry (`{ id: null }` if none is active).
 */
export const organization = state => state.organization.entry
